/**
 * @generated SignedSource<<c80f8becbf8122ac39aa79004798e1b9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TryOnType = "BRACELET" | "EARRINGS" | "EYEWEAR" | "HEADWEAR" | "NECKLACE" | "NOT_SELECTED" | "SCARVES" | "SHOES" | "WATCHES";
export type vtoEditorProductTryOnQuery$variables = {
  productTryOnId: string;
};
export type vtoEditorProductTryOnQuery$data = {
  readonly productTryOn: {
    readonly code: string | null;
    readonly id: string;
    readonly name: string | null;
    readonly productID: number;
    readonly providerID: number;
    readonly settings: string | null;
    readonly typeID: TryOnType;
  } | null;
};
export type vtoEditorProductTryOnQuery = {
  response: vtoEditorProductTryOnQuery$data;
  variables: vtoEditorProductTryOnQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productTryOnId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "productTryOnId"
      }
    ],
    "concreteType": "ProductTryOn",
    "kind": "LinkedField",
    "name": "productTryOn",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "typeID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "providerID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "settings",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "vtoEditorProductTryOnQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "vtoEditorProductTryOnQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "f178b80b3e8c1955734f56ba36ee43a6",
    "id": null,
    "metadata": {},
    "name": "vtoEditorProductTryOnQuery",
    "operationKind": "query",
    "text": "query vtoEditorProductTryOnQuery(\n  $productTryOnId: ID!\n) {\n  productTryOn(id: $productTryOnId) {\n    id\n    productID\n    typeID\n    providerID\n    name\n    code\n    settings\n  }\n}\n"
  }
};
})();

(node as any).hash = "061b2d6f39a47e6a9bb5746b63ccc516";

export default node;
